module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-17 at 11.31.39.96fa0165.png";